<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-file-upload
      v-model="form.recording"
      accept=".mp3"
      help-text="Must be an .mp3 file and less than 2MB, here is a website to create a .mp3 https://online-voice-recorder.com/"
    ></form-field-file-upload>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "RecordingForm",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        market_id: this.$store.getters.market.id,
        type: "",
        label: "",
        recording: null,
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  methods: {
    create() {
      return this.$api.recordings.create(this.form)
        .then(response => {
          this.$buefy.toast.open({
            message: "Recording was created",
            type: "is-success"
          });

          this.$emit('created', response.data);

          return response;
        });
    },
    delete() {
      return this.$api.recordings.delete(this.form.id)
        .then(res => {
          this.$buefy.toast.open({
            message: "Recording was archived",
            type: "is-success"
          });

          return res;
        });
    },
  },
};
</script>
